import { SVGPureIcon } from '@/ui';
import AppCheckBox from '@/ui/checkbox';
import deleteMenuStore from './store';
import IconButton from '@/components/chat-history/IconButton';
import { HelpOther } from '@/common/helper';
import chatStoreManager from '@/store/chat/manager';
import navbarStore from '@/store/navbar';
import { observer } from 'mobx-react-lite';
import globalStore from '@/store/global';
import { Dropdown } from 'antd';
import { useParams } from 'react-router-dom';
import appLogger from '@public/log/monitor';
import userStore from '@src/store/user';
import { useEffect } from 'react';
import { Tooltip } from 'antd';

const dropList = (scene="") => {
  return (
    <div
      className={`w-[150px] px-[8px] py-[8px] rounded-[12px] flex flex-col ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
      style={{
        boxShadow: '0px 2px 8px 0px #0000001A',
        border: '1px solid rgba(0,0,0,0.1)',
      }}
    >
      <div
        className={`w-full h-[40px] rounded-[8px] font-bold text-[14px] text-[#000] flex items-center cursor-pointer hover:bg-[#000] hover:bg-opacity-4 ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
        onClick={() => {
          deleteMenuStore.doEidt();
          deleteMenuStore.toggleDropdown(false);
        }}
      >
        <IconButton
          className="!hover:bg-transparent"
          icon="edit"
          size={20}
        ></IconButton>
        选择
      </div>
      <div
        className={`w-full h-[40px] rounded-[8px] font-bold text-[14px] text-[#FF3B30] flex items-center cursor-pointer hover:bg-[#FEF5F6] ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
        onClick={() => {
          deleteMenuStore.toggleDropdown(false);
          HelpOther.confirm({
            title: '确认清空所有对话',
            okText: '删除',
            content: (
              <div className="whitespace-nowrap">
                确定要清除所有对话吗？清空后对话内容将不可恢复。
              </div>
            ),
            onOk: () => {
              if (chatStoreManager.current?.isAITyping) {
                chatStoreManager.current.abort(() => {
                  navbarStore.clearHistory('', true, '1', scene == "aigent" ? 1 : 5);
                });
              } else {
                navbarStore.clearHistory('', true, '1', scene == "aigent" ? 1 : 5);
              }
              const isHomePage = location.pathname === '/';
              appLogger.log({
                key: `${isHomePage ? 'aibot_home' : 'aibot_chat'}`,
                action: 'click',
                arrt: 'del_chat',
                conversation_id: 'all',
              });
            },
          });
        }}
      >
        <IconButton
          className="!hover:bg-transparent"
          icon="icon_delete_dropdown"
          size={20}
        ></IconButton>
        清除所有对话
      </div>
    </div>
  );
};

const DeleteMenu = ({ className, hideMore, scene="" }) => {
  const { id } = useParams();
  const checked = deleteMenuStore.deleteIds.length;
  const notAll =
    checked &&
    deleteMenuStore.deleteIds.length != navbarStore.historyList.length;

  useEffect(() => {
    deleteMenuStore.reset()
    return () => {
      deleteMenuStore.reset()
    }
  }, [])

  return (
    <div
      className={[
        'h-40px flex items-center justify-between',
        'text-14px font-bold mt-16px',
        className,
        deleteMenuStore.isEdit ? 'h-0px' : '',
      ]}
    >
      {deleteMenuStore.isEdit ?    <div className="flex items-start justify-center flex-col p-14px absolute bottom-0 z-999 w-full h-98px bg-[#F5F5F5]">
          <div className="flex items-center">
            <AppCheckBox
              className="!block !w-16px !h-16px cursor-pointer"
              notAll={notAll}
              checked={checked}
              onClick={evt => {
                if (checked) {
                  // 最多选 100 个，大于等于 100 取消全选
                  if (notAll && deleteMenuStore.deleteIds.length < 100) {
                    //全选
                    deleteMenuStore.checkAll();
                  } else {
                    //取消全选
                    deleteMenuStore.uncheckAll();
                  }
                } else {
                  //全选
                  deleteMenuStore.checkAll();
                }
              }}
            />
            <div className="ml-10px">
              已选择 {deleteMenuStore.deleteIds.length} 项
            </div>
          </div>
        <div className="flex items-center gap-12px mt-14px">
            <div
              onClick={deleteMenuStore.exitEidt}
              className="font-normal w-110px h-36px py-8px px-16px vh-center cursor-pointer bg-white hover:bg-[rgba(0,0,0,0.03)] rounded-6px border-1px border-solid border-[rgba(0,0,0,0.10)]"
            >
              {/* <Tooltip title='关闭'>
                <span className='cursor-pointer'>
                  <SVGPureIcon
                    name="delete_close"
                    iconClass="text-primary"
                    size={24}
                  />
                </span>
              </Tooltip> */}
              取消
            </div>
            <div
              onClick={evt => {
                if (!deleteMenuStore.deleteIds.length) return;
                HelpOther.confirm({
                  title: '确认删除对话',
                  okText: '删除',
                  content: (
                    <div className="whitespace-nowrap">
                      确定要删除对话吗？删除后对话内容将不可恢复。
                    </div>
                  ),
                  onOk: () => {
                    const isHasCur = deleteMenuStore.deleteIds.includes(id);
                    if (isHasCur) {
                      if (chatStoreManager.current?.isAITyping) {
                        chatStoreManager.current.abort(() => {
                          navbarStore.clearHistory(
                            deleteMenuStore.deleteIds,
                            true
                          );
                        });
                      } else {
                        navbarStore.clearHistory(
                          deleteMenuStore.deleteIds,
                          true
                        );
                      }
                    } else {
                      navbarStore.clearHistory(deleteMenuStore.deleteIds);
                    }
                    const isHomePage = location.pathname === '/';
                    appLogger.log({
                      key: `${isHomePage ? 'aibot_home' : 'aibot_chat'}`,
                      action: 'click',
                      arrt: 'del_chat',
                      conversation_id: deleteMenuStore.deleteIds.join(','),
                    });
                  },
                });
                evt.stopPropagation();
              }}
            className={[
              'font-normal w-110px h-36px py-8px px-16px vh-center rounded-6px border-1px border-solid border-[rgba(0,0,0,0.10)] bg-[#FF3B30] opacity-30 text-white text-14px',
              deleteMenuStore.deleteIds.length ? 'cursor-pointer opacity-100 hover:bg-[#E1051B]' : '',
            ]}
            >
              {/* <Tooltip title='删除所选'>
                <span className='cursor-pointer'>
                  <SVGPureIcon
                    name="icon_delete"
                    iconClass={[
                      'text-primary-opacity',
                      deleteMenuStore.deleteIds.length ? '' : 'text-opacity-30',
                    ]}
                    size={16}
                  />
                </span>
              </Tooltip> */}
              删除
            </div>
          </div>
      </div> : <div className="ml-8px">
        <div className="text-16px">最近</div>
      </div>}
      {userStore.isUser && <div className="">
        {deleteMenuStore.isEdit ? (
          null
        ) : (
          <Dropdown
            dropdownRender={() => dropList(scene)}
            trigger="click"
            placement="bottomLeft"
            open={deleteMenuStore.showDropdown}
            onOpenChange={visible => {
              deleteMenuStore.toggleDropdown(visible);
            }}
          >
            <IconButton
              className={[
                '!hover:bg-[rgba(0,0,0,0.03)] !p-0',
                deleteMenuStore.showDropdown ? 'bg-[rgba(0,0,0,0.03)]' : '',
                hideMore ? 'hidden' : '', //进入搜索模式之后就不展示删除菜单入口
                '!rounded-6px'
              ]}
              iconClassName='text-[rgb(0,0,0,.7)]'
              icon="more"
              size={24}
              onClick={evt => {}}
            />
          </Dropdown>
        )}
      </div>}
    </div>
  );
};

export default observer(DeleteMenu);
